import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";

import { useLoadData } from "../../../hooks/useLoadData";
import { ApiResponse } from "../../../models/api-response";
import { usersApiKeyStore } from "../../../api/users-api-key-store";
import { LoadingIndicator } from "../../../components/loading-indicator.component";
import { departmentsApiKeyStore } from "../../../api/masters/department-api-key-store";
import FormInput from "../../query-builder/hooks-form-querybuilder/form-input.component";
import { FormSelect } from "../../query-builder/hooks-form-querybuilder/form-select.component";
import { FormAutoCompleteSelectDynamic } from "../../query-builder/hooks-form-querybuilder/form-autocomplete-select.dynamic.component";

export const DepartmentForm = () => {

    const [quickbookOption, setQuickbookOption] = useState<any[]>([]);
    const { setValue, getValues } = useFormContext();
    const departmentID = getValues('departmentID');
    const { data: qbDepartmentData, isLoading: isQBDepartmentLoading } = useLoadData<ApiResponse<any[]>>(departmentsApiKeyStore.getQBODepartments());
    const { isLoading, isFetching, data } = useLoadData<ApiResponse<any>>(departmentsApiKeyStore.getDepartmentById(departmentID), !!departmentID);

    useEffect(() => {
        if (qbDepartmentData) {
            const formattedData =
                qbDepartmentData?.data?.map(item => ({
                    value: item.qboDepartmentID,
                    label: item.qboDepartmentName,
                    isDefault: false,
                })) || [];

            const finalData = [
                { value: 'N/A', label: 'N/A', isDefault: false },
                ...formattedData,
            ];

            setQuickbookOption(finalData);
        }
    }, [qbDepartmentData]);


    useEffect(() => {
        if (getValues('qboDepartmentID') == "" || getValues('qboDepartmentID') == null)
            setValue('qboDepartmentID', 'N/A')
    }, [getValues('qboDepartmentID')])


    if (data) {
        setValue('manager', { userID: data?.data?.managerID ?? 0, fullName: data?.data?.managerName ?? '' });
    }

    return (
        <Grid container spacing={2}>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
                <FormInput
                    label="Department Name"
                    name="departmentName"
                    maxLength={150}
                    autoFocus
                />
            </Grid>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
                <FormAutoCompleteSelectDynamic
                    name="manager"
                    label="Manager"
                    getQueryKeyConfig={() => usersApiKeyStore.getUsers()}
                    optionsValueKey="userID"
                    optionsLabelKey="fullName"
                    isParentLoading={isLoading || isFetching}
                />
            </Grid>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
                <LoadingIndicator isLoading={isQBDepartmentLoading} />
                <FormSelect
                    label="QuickBooks Location"
                    name="qboDepartmentID"
                    options={quickbookOption} />
            </Grid>
        </Grid>
    );
}